module.exports = __webpack_public_path__ + "img/ruim.161c0188.png";